/// <reference types="vite-plugin-svgr/client" />
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';
import { Logo } from '../logos/logo';
import ContextualWordmark from '../logos/contextual-wordmark.svg?react';
import { Link } from 'react-router-dom';
import type { SVGProps } from 'react';

// Add type for the SVG component
const WordmarkLogo = ContextualWordmark as React.FC<SVGProps<SVGSVGElement>>;

export function LogoSection() {
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton
          className="
           data-[state=open]:bg-sidebar-accent
           p-0
           data-[state=open]:text-sidebar-accent-foreground
            group-data-[collapsible=icon]:!p-0
            hover:bg-transparent
            active:bg-transparent
          "
          size="lg"
          asChild
        >
          <Link to="/" className="flex items-center justify-center w-full h-full px-2">
            <div className="flex aspect-square size-8 items-center justify-center rounded-md">
              <Logo icon="contextual" width={32} height={32} />
            </div>
            <div className="flex-1 flex items-center group-data-[collapsible=icon]:hidden">
              <WordmarkLogo className="w-32 h-8" />
            </div>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
